module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), (this.$route.query.id == undefined) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('button', {
    staticClass: "fl-button",
    attrs: {
      "title": "Új igénylés"
    },
    on: {
      "click": function($event) {
        _vm.popup.request = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('h1', [_vm._v("Vonalkód igénylések")]), _vm._v(" "), (_vm.requests.length > 0) ? _c('div', {
    staticClass: "table-with-title"
  }, [_c('table', {
    ref: "abc",
    staticClass: "list"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.requests), function(request) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(request.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.request_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.groupname))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(request.barcode_email_sent_amount) + " / " + _vm._s(request.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.comment))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(request.approved == 0) ? _c('i', {
      staticClass: "fa fa-minus"
    }) : _vm._e(), _vm._v(" "), (request.approved == 1) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.approved_date))]), _vm._v(" "), _c('td', {
      staticClass: "buttons"
    }, [(request.approved == 1) ? _c('button', {
      staticClass: "small-button",
      attrs: {
        "title": "Vonalkódok beállítása"
      },
      on: {
        "click": function($event) {
          return _vm.setBarcodes(request.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-cog"
    })]) : _vm._e(), _vm._v(" "), (request.approved == 0 && request.user_id == _vm.$root.user.element_id) ? _c('button', {
      staticClass: "small-button",
      attrs: {
        "title": "Igénylés módosítása"
      },
      on: {
        "click": function($event) {
          _vm.request_id = request.id;
          _vm.popup.request = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-alt"
    })]) : _vm._e(), _vm._v(" "), (request.approved == 0 && request.user_id == _vm.$root.user.element_id) ? _c('button', {
      staticClass: "small-button",
      attrs: {
        "title": "Igénylés törlése"
      },
      on: {
        "click": function($event) {
          return _vm.del(request.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-alt"
    })]) : _vm._e()])])
  })], 2)]) : _c('div', [_vm._v("\n            Még nem igényelt vonalkódokat.\n          ")])]), _vm._v(" "), (_vm.popup.request) ? _c('BarcodeRequestPopup', {
    attrs: {
      "id": _vm.request_id
    },
    on: {
      "close": function($event) {
        _vm.popup.request = false;
      },
      "success": _vm.getRequests
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.$route.query.id != undefined) ? _c('BarcodeRequestSetup', {
    on: {
      "save_start": function($event) {
        _vm.is_save = true;
      },
      "save_finish": function($event) {
        _vm.is_save = false;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Igénylő")]), _vm._v(" "), _c('th', [_vm._v("Igénylés dátuma")]), _vm._v(" "), _c('th', [_vm._v("Csoport")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Mennyiség")]), _vm._v(" "), _c('th', [_vm._v("Megjegyzés")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Jóváhagyva")]), _vm._v(" "), _c('th', [_vm._v("Jóváhagyás dátuma")]), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46e07c34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/barcode_request.vue
// module id = 298
// module chunks = 0